// src/modules/app-views/ticketEvents/pages/Document/components/CardHeaderEventTags.jsx
import { Tag, Tooltip } from 'antd';
import translateX from 'utils/translateX';

const STATUS_COLORS = {
  draft: 'default',
  active: 'green',
  paused: 'orange',
  ended: 'blue',
  'sold-out': 'red',
};

const STATUS_KEYS = {
  draft: 'draft',
  active: 'active',
  paused: 'paused',
  ended: 'ended',
  'sold-out': 'sold_out',
};

const CardHeaderEventTags = ({ data }) => {
  const status = data?.status;
  if (!status) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <Tooltip title={translateX('status')}>
        <Tag color={STATUS_COLORS[status] || 'default'} style={{ margin: 0 }}>
          {translateX(STATUS_KEYS[status] || status)}
        </Tag>
      </Tooltip>
    </div>
  );
};

export default CardHeaderEventTags;
